import SelectField from 'myshubhlife-component/selectField';
import * as React from 'react';
import {IDropdownProps} from 'myshubhlife-component/form/FormInterfaceProps';


function Dropdown (props: IDropdownProps) {
  const handleSelectChange = (fieldName: string, value: string | number) => {
    props.handleFormChange(value, props.index, 'value');
  }
  const handleBlur = (value) => {
    if (!props.field.value && props.field.value !== 0 && props.field.isRequired !== false) {
      props.handleFormChange('This field is required', props.index, 'errorMsg');
    } else {
      props.handleFormChange('', props.index, 'errorMsg');
    }
  }
  return (
    <div className="s-form-group-field">
      <SelectField
        fieldName={props.field.identifier}
        options={props.field.options}
        index={props.index}
        value={props.field.value}
        onChangeHandler={handleSelectChange}
        handleBlur={handleBlur}
        name={props.field.label}
        errorMsg={props.field.errorMsg}
        isRequired={props.field.isRequired}
        tooltipLabel={props.field.tooltipLabel}
        validated={props.field.validated}
        styleType={props.styleType}
      />
    </div>
  )
}

export default Dropdown;